import React from 'react';
import {
  Card,
  CardBody,
  VStack,
  HStack,
  Text,
  FormControl,
  FormLabel,
  Alert,
  AlertIcon,
  Spinner,
  Badge,
  Wrap,
  WrapItem,
  useColorModeValue,
  Icon,
  Box,
} from '@chakra-ui/react';
import { FaProjectDiagram } from 'react-icons/fa';
import Select from 'react-select';

const SchemeSelectionCard = ({
  addUser,
  roleConfig,
  loadingSchemes,
  schemes,
  mappedSchemes,
  selectStyles,
  handleSchemeChange,
  schemeRoleMapping,
}) => {
  const modalTextColor = useColorModeValue('gray.800', 'white');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const labelColor = useColorModeValue('gray.700', 'gray.200');
  const cardBg = useColorModeValue('white', 'gray.800');

  if (!addUser.role || !addUser.department || addUser.department.length === 0)
    return null;

  return (
    <Card
      mb={6}
      boxShadow="sm"
      border="1px solid"
      borderColor={borderColor}
      bg={cardBg}
    >
      <CardBody>
        <VStack align="start" spacing={4}>
          <HStack spacing={2}>
            <Icon as={FaProjectDiagram} color="green.500" />
            <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
              Step 3: Select Scheme(s)
            </Text>
          </HStack>

          <Text fontSize="sm" color={subtitleColor} mb={4}>
            {roleConfig[addUser.role]?.allowedSchemes === 'pmJanman'
              ? 'PM-JANMAN scheme is automatically selected for Project Officer'
              : roleConfig[addUser.role]?.allowedSchemes === 'landAcquisition'
              ? 'Land Acquisition scheme is automatically selected for Sub Divisional Officer'
              : 'Select scheme(s) this user will work with'}
          </Text>

          <FormControl isRequired>
            <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
              Scheme(s)
            </FormLabel>

            {loadingSchemes ? (
              <HStack spacing={2}>
                <Spinner size="sm" />
                <Text fontSize="sm" color={subtitleColor}>
                  Loading schemes...
                </Text>
              </HStack>
            ) : schemes.length === 0 ? (
              <Alert status="info" size="sm">
                <AlertIcon />
                No schemes available for the selected department and role
              </Alert>
            ) : (
              <Select
                options={mappedSchemes}
                styles={selectStyles}
                value={mappedSchemes.filter((scheme) =>
                  addUser.schemes.includes(scheme.value),
                )}
                onChange={handleSchemeChange}
                placeholder="Select scheme(s)"
                isMulti
              />
            )}
          </FormControl>

          {addUser.schemes.length > 0 && (
            <Box w="full">
              <Text fontSize="sm" fontWeight="medium" color={labelColor} mb={2}>
                Selected Scheme(s) ({addUser.schemes.length})
              </Text>
              <Wrap spacing={2}>
                {addUser.schemes.map((schemeId) => {
                  const scheme = schemes.find((s) => s._id === schemeId);
                  const schemeInfo = schemeRoleMapping[schemeId];
                  return (
                    <WrapItem key={schemeId}>
                      <Badge
                        colorScheme={schemeInfo?.color || 'blue'}
                        px={3}
                        py={1}
                        borderRadius="full"
                      >
                        {scheme?.name || 'Scheme'}
                      </Badge>
                    </WrapItem>
                  );
                })}
              </Wrap>
            </Box>
          )}
        </VStack>
      </CardBody>
    </Card>
  );
};

export default SchemeSelectionCard;
